import { render, staticRenderFns } from "./tramitar.vue?vue&type=template&id=55d9cb9c&scoped=true"
import script from "./tramitar.vue?vue&type=script&lang=js"
export * from "./tramitar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d9cb9c",
  null
  
)

export default component.exports